import { createAction, props } from '@ngrx/store';

export const viewToast = createAction('[COMMON TOAST] View Toast', props<{ message: string }>());

export const hideToast = createAction('[COMMON TOAST] Hide Toast');
